__webpack_require__.p = "/energy/paper/Geographical_Information_System/";